module.exports = __webpack_public_path__ + "media/images/emblems/Masein_wappen-efd2403e2da6b7c30231f04ca794d27b.svg";